/**
 * Article reading progress (sections/article.liquid): a 2px rule, sticky
 * directly under the header, that fills as the article body is read. Offset
 * from the top accounts for a merchant-enabled sticky header so the two
 * bars never overlap; when the header isn't sticky the rule just sticks to
 * the very top of the viewport once scrolled past.
 */
function initReadingProgress() {
  const bar = document.querySelector('[data-reading-progress]');
  const fill = document.querySelector('[data-reading-progress-fill]');
  const source = document.querySelector('[data-reading-progress-source]');
  if (!bar || !fill || !source) return;

  function setOffset() {
    const header = document.querySelector('.site-header');
    const isSticky = header?.classList.contains('site-header--sticky');
    bar.style.top = isSticky ? `${header.getBoundingClientRect().height}px` : '0px';
  }

  function update() {
    const rect = source.getBoundingClientRect();
    const total = rect.height + window.innerHeight;
    const scrolled = window.innerHeight - rect.top;
    const percent = total > 0 ? Math.min(100, Math.max(0, (scrolled / total) * 100)) : 0;
    fill.style.width = `${percent}%`;
  }

  setOffset();
  update();
  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', () => {
    setOffset();
    update();
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initReadingProgress);
} else {
  initReadingProgress();
}
